// extracted by mini-css-extract-plugin
module.exports = {"contextMenuBox":"ContextMenu_contextMenuBox__2wsLT","show":"ContextMenu_show__3R3f6","contextMenuItem":"ContextMenu_contextMenuItem__24W18"};